import type { Options } from '@atlassian/jira-issue-field-checkbox/src/ui/edit/types.tsx';
import { MUTATION_GROUP } from './constants.tsx';
import type { JiraCheckboxFieldInput } from './types.tsx';

export const mutateCheckboxField = (values: Options, fieldId: string): JiraCheckboxFieldInput => {
	const transformedValues = values.map(({ value }: { value: string }) => ({
		optionId: value,
	}));

	return {
		fieldId,
		mutationGroup: MUTATION_GROUP,
		options: transformedValues,
	};
};
